(function(){
  document.addEventListener('tooltip:show', function(event) {
    const { container, msg, duration } = event.detail;
    if (!container || !msg) return;
    if (container.querySelector('.tooltip')) container.querySelector('.tooltip').remove();

    const tooltip = document.createElement('span');
    tooltip.innerHTML = `<span class="tooltip__label">${msg}</span>`;
    tooltip.classList.add('tooltip');
    container.append(tooltip);

    if (duration) {
      setTimeout(function() {
        tooltip.remove();
      }, duration);
    }
  });

  document.addEventListener('tooltip:hide', function(event) {
    const { container } = event.detail;
    if (container.querySelector('.tooltip')) container.querySelector('.tooltip').remove();
  });

  function handleWeglotMetafields() {
    const lang = Weglot.getCurrentLang() === 'en' ? 'en' : 'zh';
    document.querySelectorAll('.i18n-metafield').forEach(function(el) {
      const key = el.dataset.key;
      var target_key = key + '_' + lang;
      const target = document.querySelector(`.i18n-data[data-key=${target_key}]`);
      if (target) {
        el.innerHTML = document.querySelector(`.i18n-data[data-key=${target_key}]`).innerHTML;
      }
    });
    if (lang === 'en') {
      document.querySelectorAll('.i18n-zh').forEach(function(el) {
        el.style.display = 'none';
      }.bind(this));
      document.querySelectorAll('.i18n-en').forEach(function(el) {
        el.style.display = 'inline-block';
      }.bind(this));
    }

    if (lang === 'zh') {
      document.querySelectorAll('.i18n-zh').forEach(function(el) {
        el.style.display = 'inline-block';
      }.bind(this));
      document.querySelectorAll('.i18n-en').forEach(function(el) {
        el.style.display = 'none';
      }.bind(this));
    }
  }
  // Weglot.on("initialized", handleWeglotMetafields);
  // Weglot.on("languageChanged", handleWeglotMetafields);

  const productPromoSeeDetail = document.querySelectorAll('.product-promo-tag-see-detail');
  if (productPromoSeeDetail.length > 0) {
    productPromoSeeDetail.forEach(function(el) {
      el.addEventListener('click', function() {
        console.log('click');
        productPromoSeeDetail.forEach(function(el2) {
          console.log(el2);
          el2.querySelector('.more-label').style.display = 'none';
        });
      });
    });
  }
})();


/** Coupon section **/
(function() {
  document.querySelectorAll('.featured-collection[data-has-countdown]').forEach((container) => {
    const fullDate = container.dataset.endDate;
    const arr = fullDate.split(/[- :]/);
    const endDate = (new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4])).valueOf();

    const seconds = container.querySelectorAll('[data-countdown=seconds]');
    const minutes = container.querySelectorAll('[data-countdown=minutes]');
    const hours = container.querySelectorAll('[data-countdown=hours]');
    const days = container.querySelectorAll('[data-countdown=days]');

    const counter = setInterval(() => {
      updateTimer();
    }, 1000);

    function updateTimer() {
      function updateForEach(els, val) {
        els.forEach(el => el.innerHTML = val);
      }

      if (isNaN(endDate)) {
        endDate = (new Date(container.dataset.endDate)).valueOf();
        return;
      }

      const now = (new Date()).valueOf(), d = endDate - now;

      if (d > 0) {
        updateForEach(seconds, Math.floor(d / 1000) % 60);
        updateForEach(minutes, Math.floor(d / 60000) % 60);
        updateForEach(hours, Math.floor(d / 3600000) % 24);
        updateForEach(days, Math.floor(d / 86400000));
      } else {
        clearInterval(counter);
        container.remove();
      }
    }
  });
})();


(function() {
  const coupons = document.querySelectorAll('.save-coupon-code__button');
  coupons.forEach((el) => {
    const code = el.querySelector('.save-coupon-code__input');
    el.addEventListener('click', (e) => {
      code.focus();
      code.select();
      try {
        document.execCommand('copy');
      } catch (e) {
        console.log('Oops, cannot copy!', e);
      }
      code.blur();

      el.classList.add('save-coupon-code__button--show-copied');

      setTimeout(() => {
        el.classList.remove('save-coupon-code__button--show-copied');
      }, 3000);
    });

    code.addEventListener('change', (e) => {
      code.value = el.dataset.code;
    });
  });
})();

/* Match height custom */
$(function() {
  function setMatchHeightAppInfo() {
    const windowWidth = $(window).innerWidth();
    $('[data-custom-mh="app-page__grid"]').css('height', '');

    const $customItemAppInfo = $('.custom__item--app-info[data-custom-mh="app-page__grid"]');
    const $customItemVideo = $('.custom__item--video[data-custom-mh="app-page__grid"]');

    if ($customItemAppInfo.innerHeight() < $customItemVideo.innerHeight()) {
      $customItemAppInfo.css('height', $customItemVideo.innerHeight());
      $customItemVideo.css('height', $customItemVideo.innerHeight());
    } else {
      $customItemVideo.css('height', $customItemAppInfo.innerHeight());
      $customItemAppInfo.css('height', $customItemAppInfo.innerHeight());
    }
  }

  $(window).on('resize', setMatchHeightAppInfo);
  // Weglot.on("languageChanged", setMatchHeightAppInfo)
  setMatchHeightAppInfo();
});
